<template>
  <div class="home-dashboard-hub">
    <b-card no-body class="home-dashboard-tabs-card mb-2">
      <b-card-body class="py-1 px-1">
        <b-nav pills class="home-dashboard-tabs">
          <b-nav-item
            :active="activeTab === TAB_DASHBOARD"
            @click="setTab(TAB_DASHBOARD)"
          >
            <feather-icon icon="HomeIcon" size="16" class="mr-50" />
            Dashboard
          </b-nav-item>
          <b-nav-item
            :active="activeTab === TAB_CRM"
            @click="setTab(TAB_CRM)"
          >
            <feather-icon icon="BarChart2Icon" size="16" class="mr-50" />
            CRM Dashboard
          </b-nav-item>
        </b-nav>
      </b-card-body>
    </b-card>

    <div class="home-dashboard-panel">
      <analytics-dashboard v-if="activeTab === TAB_DASHBOARD" :key="'main-dashboard'" />
      <crm-management-dashboard
        v-else-if="activeTab === TAB_CRM"
        :key="'crm-dashboard'"
      />
    </div>
  </div>
</template>

<script>
import { BCard, BCardBody, BNav, BNavItem } from "bootstrap-vue";
import AnalyticsDashboard from "@/views/dashboard/analytics/Analytics.vue";
import CrmManagementDashboard from "@/views/crm/CrmManagementDashboard.vue";

const TAB_DASHBOARD = "dashboard";
const TAB_CRM = "crm";
const STORAGE_KEY = "homeDashboardActiveTab";

export default {
  name: "HomeDashboardHub",
  components: {
    BCard,
    BCardBody,
    BNav,
    BNavItem,
    AnalyticsDashboard,
    CrmManagementDashboard,
  },
  data() {
    return {
      TAB_DASHBOARD,
      TAB_CRM,
      activeTab: TAB_DASHBOARD,
    };
  },
  watch: {
    "$route.query.tab": {
      immediate: true,
      handler() {
        this.syncTabFromRoute();
      },
    },
  },
  mounted() {
    this.syncTabFromRoute();
  },
  methods: {
    syncTabFromRoute() {
      const tab = (this.$route.query.tab || "").toString().toLowerCase();
      if (tab === TAB_CRM || tab === "crm-dashboard") {
        this.activeTab = TAB_CRM;
        return;
      }
      if (tab === TAB_DASHBOARD || tab === "analytics") {
        this.activeTab = TAB_DASHBOARD;
        return;
      }
      const stored = localStorage.getItem(STORAGE_KEY);
      this.activeTab = stored === TAB_CRM ? TAB_CRM : TAB_DASHBOARD;
    },
    setTab(tab) {
      if (this.activeTab === tab) {
        return;
      }
      this.activeTab = tab;
      localStorage.setItem(STORAGE_KEY, tab);

      const query = tab === TAB_CRM ? { tab: TAB_CRM } : {};
      if (this.$route.path === "/" && JSON.stringify(this.$route.query) === JSON.stringify(query)) {
        return;
      }
      this.$router
        .replace({ path: "/", query })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.home-dashboard-tabs-card {
  border-radius: 0.428rem;
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
}

.home-dashboard-tabs >>> .nav-link {
  font-weight: 600;
  padding: 0.6rem 1.25rem;
  border-radius: 0.358rem;
}

.home-dashboard-tabs >>> .nav-item {
  margin-right: 0.35rem;
}

.home-dashboard-panel {
  min-height: 200px;
}
</style>
